import { render, staticRenderFns } from "./selectExpertDepartment.vue?vue&type=template&id=3d56c1dc&scoped=true&"
import script from "./selectExpertDepartment.vue?vue&type=script&lang=js&"
export * from "./selectExpertDepartment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.10.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.6.14_webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d56c1dc",
  null
  
)

export default component.exports